export const Lang = {
  title: 'St. Andrews Links Information',
  addTitle: 'Add new location form',
  editTitle: 'Edit Location form',
  allTitle: 'List of all locations',
  form: {
    titles: {
      mandatory: '1. Mandatory fields',
      optional: '2. Optional fields',
    },
    labels: {
      name: 'Name',
      description: 'Description',
      latitude: 'Latitude',
      longitude: 'Longitude',
      category: 'Category',
      type: 'Location Type',
      course: 'Course',
      shop: 'Shop',
    },
    buttons: {
      edit: 'Update',
      delete: 'Delete',
      cancel: 'Cancel',
      store: 'Save',
      add: '+ Add new location',
    },
    validation: {
      name: {
        required: 'Location name is required',
        length: 'Location name must not be longer than 50 characters',
      },
      latitude: {
        required: 'Latitude value is required',
        regex: 'Must be a valid latitude',
      },
      longitude: {
        required: 'Longitude value is required',
        regex: 'Must be a valid longitude',
      },
      category: {
        required: 'Category must be selected',
      },
      type: {
        required: 'Location Type must be selected',
      },
    },
  },
  toast: {
    success: {
      store: 'New Location has been added',
      update: 'Location has been updated',
      delete: 'Location has been deleted',
    },
    error: 'Oops! Something went wrong',
  },
};
